module.exports = __webpack_public_path__ + "static/failure-and-beyond-fd0b5b3f9ee85f792690b7cd798e07f8.jpg";